import { BitkitExpandableCard, IconClock, useResponsive } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import useManualApprovalBuildList, {
  ManualApprovalBuild,
} from '@/pages/App/AppDetails/components/BuildsSection/ManualApprovalBuildList/hooks/useManualApprovalBuildList';
import ManualApprovalBuildListItem from '@/pages/App/AppDetails/components/BuildsSection/ManualApprovalBuildList/ManualApprovalBuildListItem';
import { SettingsPageAbilities } from '@/pages/App/AppSettings/types/SettingsPageAbilities';
import AppForAppPage from '@/pages/App/types/AppForAppPage';

type ManualApprovalBuildListProps = {
  app: AppForAppPage;
  abilities: SettingsPageAbilities;
};

const ManualApprovalBuildList = ({ app, abilities }: ManualApprovalBuildListProps) => {
  const { isMobile } = useResponsive();

  const { data: manualApprovalBuildList, refetch } = useManualApprovalBuildList({
    appSlug: app.slug,
    enabled: Boolean(abilities.canApproveBuildRequest),
  });

  if (!!manualApprovalBuildList && manualApprovalBuildList.length > 0) {
    return (
      <BitkitExpandableCard
        defaultExpanded
        elevation={false}
        icon={IconClock}
        title={
          <Box display="flex" alignItems="center" gap="4">
            <Text as="span" textStyle="body/lg/semibold">
              Manual approval builds
            </Text>
            <Text
              as="span"
              textStyle="body/sm/regular"
              color="text/secondary"
              backgroundColor="background/tertiary"
              borderRadius="4"
              paddingInline="8"
              paddingBlock="4"
            >
              {manualApprovalBuildList.length}
            </Text>
          </Box>
        }
        zIndex={isMobile ? 0 : 2}
      >
        {manualApprovalBuildList.map((anItem: ManualApprovalBuild, index) => (
          <ManualApprovalBuildListItem
            key={anItem.slug}
            app={app}
            manualApprovalBuildItem={anItem}
            onRefresh={refetch}
            marginBlockEnd={index < manualApprovalBuildList.length - 1 ? '16' : undefined}
          />
        ))}
      </BitkitExpandableCard>
    );
  }

  return null;
};

export default ManualApprovalBuildList;
